import cn from 'clsx'
import type { TDetailsRowProps, TDetailsRowsProps } from './DetailsRows.types'
import styles from './DetailsRows.module.css'

export const DetailsRow = ({ label, value, excludeFromPageGuardian }: TDetailsRowProps) => (
    <div
        className={styles.row}
        role="listitem"
        {...(excludeFromPageGuardian ? { 'data-exclude-page-guardian': true } : {})}
    >
        <span className={styles.label}>{label}</span>
        <span className={styles.value}>{value}</span>
    </div>
)

export const DetailsRows = ({
    rows,
    className,
    ariaLabel = 'Details',
    rowsSlot,
}: TDetailsRowsProps) => (
    <div className={cn(styles.rows, className)} role="list" aria-label={ariaLabel}>
        {rowsSlot ??
            rows.map(row => (
                <DetailsRow
                    key={row.label}
                    label={row.label}
                    value={row.value}
                    excludeFromPageGuardian={row.excludeFromPageGuardian}
                />
            ))}
    </div>
)
